import { APIProvider } from '@vis.gl/react-google-maps'
import { ReactNode } from 'react'
import { useMapConfig } from '@/hooks/useMapConfig'

interface Props {
  children: ReactNode
}

export function MapsApiProvider({ children }: Props) {
  const { data: config } = useMapConfig()

  // The Google Maps JS API can only be loaded ONCE per page with a given key.
  // If we mount APIProvider with apiKey="" first (before useMapConfig resolves),
  // Google injects the script with no key — and the later "real key" mount is
  // silently ignored, surfacing as ApiProjectMapError + "For development purposes
  // only" overlay. So we hold off mounting APIProvider until the config has a
  // real, non-empty key AND provider is 'google'. While we wait, render children
  // unwrapped — MapView's own loading gate (also reading useMapConfig) shows a
  // neutral placeholder during this window.
  if (!config || !config.key || config.provider !== 'google') {
    return <>{children}</>
  }

  return (
    <APIProvider apiKey={config.key} libraries={['marker']}>
      {children}
    </APIProvider>
  )
}
